/**
 * @param {HTMLFormElement} form
 */
function formParams (form) {
    //This is a bit tricky, [].fn.call(form.elements, ...) allows us to call .fn
    //on the form's elements, even though it's not an array. Effectively
    //Filtering all of the fields on the form
    let params = [].filter.call(form.elements, function(/** @type {HTMLInputElement} */ el) {
        ;
        return typeof(el.type) !== 'undefined';
    })// Unchecked checbox elements die.
    .filter(function(/** @type {HTMLInputElement} */ el) {
        if (el.type === 'checkbox' ) {
            return el.checked == true // only return checked checboxes
        }
        return el
    })
    .filter(function(/** @type {HTMLInputElement} */ el) {
        if (el.type === 'radio' ) {
            return el.checked == true // only return checked checboxes
        }
        return el
    })///Nameless elements die.
    .filter(function(el) {
        return !!el.name; }) //Nameless elements die.
    .filter(function(el) {
        return el.disabled === false;
    }) //Disabled elements die.
    .map(function(el) {
        //Map each field into a name=value string, make sure to properly escape!
        // Remove whitespace before and after with trim on value
        return encodeURIComponent(el.name) + '=' + encodeURIComponent(el.value.trim());
    }).join('&'); //Then join all the strings by &

    return params;
}

export {formParams};
